import React from 'react';
import ProfileLeaves from 'pages/userManagementV3/profileLeaves';
import GeofenceHolidaysTab from './GeofenceHolidaysTab';
import { fluid } from 'components/UserDashboardV2/utils/responsive';
import { COLORS } from 'components/UserDashboardV2/utils/constants';

import { TABS } from './constants';
import BasicDetailsTab from './BasicDetailsTab';
import CoursesAndBatchesTab from './CoursesAndBatchesTab';
import AttendanceTab from './AttendanceTab';
import ActivityTab from './ActivityTab';
import DocumentsTab from './DocumentsTab';
import FeesTab from './FeesTab';

const ProfileTabContent = ({
    activeTab,
    isStaffRoute,
    isStaff,
    isTeacher,
    profile,
    sidebarRef,
    leftColumnHeight,
    tabsData,
    attendance,
    attendanceOverview,
    setTabLoader,
    joinedDate,
}) => {
    const {
        specificUserProfile,
        staffProfile,
        studentSidebar,
        userRowDetails,
        currentAddress,
        permanentAddress,
        editingSection,
        draftProfile,
        savingSection,
        handleEditSection,
        handleCancelSection,
        handleSaveSection,
        handleDraftChange,
        showAttendanceBySubject,
        visibleMonthColumns,
    } = profile;

    const {
        enrolledCourses,
        enrolledCoursesLoading,
        setEnrollCourseModalOpen,
        setAddBatchDrawerData,
        setUnassignCourseModal,
        setChangeBatchModalData,
        setUnassignBatchModal,
        documents,
        documentsLoading,
        deletingDocId,
        setDocumentModal,
        uploadingDocuments,
        handleDeleteDocument,
        flatActivities,
        userActivityLoading,
        activityStats,
        studentFeeData,
        studentFeeLoading,
        selectedFeeCourseIndex,
        setSelectedFeeCourseIndex,
        setCancelRequestModal,
    } = tabsData;

    const {
        attendanceData,
        studentAttendanceData,
        selectedAttendanceCourseId,
        selectedAttendanceDate,
        selectedDate,
        attendanceLoading,
        dynamicCalendarMonths,
        calendarScrollContainerRef,
        currentMonthRef,
        attendanceSummaryCardRef,
        attendanceSummaryHeight,
        handleAttendanceCourseChange,
        handleAttendanceDateClick,
    } = attendance;

    return (
        <div style={{
            width: "100%",
            flex: 1,
            minHeight: 0,
            marginTop: fluid(20),
            overflow: activeTab === TABS[0].label ? "visible" : "hidden",
            display: "flex",
            flexDirection: "column"
        }}>
            {activeTab === TABS[0].label ? (
                <BasicDetailsTab
                    isStaffRoute={isStaffRoute}
                    isStaff={isStaff}
                    isTeacher={isTeacher}
                    specificUserProfile={specificUserProfile}
                    staffProfile={staffProfile}
                    studentSidebar={studentSidebar}
                    userRowDetails={userRowDetails}
                    currentAddress={currentAddress}
                    permanentAddress={permanentAddress}
                    editingSection={editingSection}
                    draftProfile={draftProfile}
                    savingSection={savingSection}
                    sidebarRef={sidebarRef}
                    handleEditSection={handleEditSection}
                    handleCancelSection={handleCancelSection}
                    handleSaveSection={handleSaveSection}
                    handleDraftChange={handleDraftChange}
                />
            ) : activeTab === TABS[1].label ? (
                <CoursesAndBatchesTab
                    enrolledCourses={enrolledCourses}
                    enrolledCoursesLoading={enrolledCoursesLoading}
                    onEnrollClick={() => setEnrollCourseModalOpen(true)}
                    onAssignNewBatch={(crs) => setChangeBatchModalData({
                        modalTitle: "Assign new batch",
                        mode: "assignNew",
                        courseName: crs.title,
                        courseId: crs.courseId || crs.id,
                        enrollmentId: crs.enrollmentId || crs.id,
                        currentStandardId: null,
                        excludeStandardIds: (crs.batches || []).map(b => b.standardId || b.id),
                    })}
                    onUnassign={(c) => setUnassignCourseModal(c)}
                    onUnassignCourse={(c) => setUnassignCourseModal(c)}
                    onChangeBatch={(crs, b) => setChangeBatchModalData({
                        modalTitle: "Change batch",
                        courseName: crs.title,
                        courseId: crs.courseId || crs.id,
                        enrollmentId: crs.enrollmentId || crs.id,
                        currentStandardId: b.standardId || b.id,
                        excludeStandardIds: (crs.batches || []).map(item => item.standardId || item.id),
                    })}
                    onUnassignBatch={(crs, b) => setUnassignBatchModal({ course: crs, batch: b })}
                    onAssignBatch={(crs) => setChangeBatchModalData({
                        modalTitle: "Assign batch",
                        courseName: crs.title,
                        courseId: crs.courseId || crs.id,
                        enrollmentId: crs.enrollmentId || crs.id,
                        currentStandardId: null,
                    })}
                />
            ) : activeTab === TABS[3].label ? (
                <AttendanceTab
                    userId={specificUserProfile?.id}
                    attendanceData={attendanceData}
                    attendanceOverview={attendanceOverview}
                    studentAttendanceData={studentAttendanceData}
                    selectedAttendanceCourseId={selectedAttendanceCourseId}
                    selectedAttendanceDate={selectedAttendanceDate}
                    selectedDate={selectedDate}
                    attendanceLoading={attendanceLoading}
                    showAttendanceBySubject={showAttendanceBySubject}
                    isTeacher={isTeacher}
                    isStaffRoute={isStaffRoute}
                    visibleMonthColumns={visibleMonthColumns}
                    dynamicCalendarMonths={dynamicCalendarMonths}
                    calendarScrollContainerRef={calendarScrollContainerRef}
                    currentMonthRef={currentMonthRef}
                    attendanceSummaryCardRef={attendanceSummaryCardRef}
                    attendanceSummaryHeight={attendanceSummaryHeight}
                    handleAttendanceCourseChange={handleAttendanceCourseChange}
                    handleAttendanceDateClick={handleAttendanceDateClick}
                />
            ) : activeTab === TABS[5].label ? (
                <ActivityTab
                    userActivityLoading={userActivityLoading}
                    flatActivities={flatActivities}
                    activityStats={activityStats}
                    isStaffRoute={isStaffRoute}
                    isTeacher={isTeacher}
                />
            ) : activeTab === TABS[4].label ? (
                <DocumentsTab
                    leftColumnHeight={leftColumnHeight}
                    documents={documents}
                    documentsLoading={documentsLoading}
                    deletingDocId={deletingDocId}
                    onAddClick={() => setDocumentModal({ mode: 'add' })}
                    uploadingDocuments={uploadingDocuments}
                    onReplaceClick={(docId) => setDocumentModal({ mode: 'replace', docId })}
                    onDeleteClick={handleDeleteDocument}
                />
            ) : (activeTab === TABS[2].label || activeTab === "Fees" || activeTab === "FEE") ? (
                <FeesTab
                    studentFeeData={studentFeeData}
                    studentFeeLoading={studentFeeLoading}
                    selectedFeeCourseIndex={selectedFeeCourseIndex}
                    setSelectedFeeCourseIndex={setSelectedFeeCourseIndex}
                    enrolledCourses={enrolledCourses}
                    setCancelRequestModal={setCancelRequestModal}
                />
            ) : activeTab === "Leaves" ? (
                <div className="staff-profile-info-scroll" style={{ flex: 1, minHeight: 0, overflowY: "auto", backgroundColor: "#FFFFFF", borderRadius: fluid(20) }}>
                    <ProfileLeaves specificUserProfile={specificUserProfile} hideApprovers yearOnly />
                </div>
            ) : activeTab === "Geofence & Holidays" ? (
                <div className="staff-profile-info-scroll" style={{ flex: 1, minHeight: 0, overflowY: "auto", backgroundColor: "#FFFFFF", borderRadius: fluid(20) }}>
                    <GeofenceHolidaysTab specificUserProfile={specificUserProfile} setPageLoader={setTabLoader} joinedDate={joinedDate} />
                </div>
            ) : (
                <div style={{ backgroundColor: "#FFFFFF", borderRadius: fluid(20), padding: `${fluid(60)} ${fluid(24)}`, textAlign: "center", color: COLORS.textLight, fontSize: fluid(16) }}>
                    {activeTab} isn't wired up yet.
                </div>
            )}
        </div>
    );
};

export default ProfileTabContent;
